"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.legacyClaimSubmissionSchema = void 0;
var account_information_submission_schema_1 = require("./account-information-submission-schema");
var borrower_submission_schema_1 = require("./borrower-submission-schema");
var claim_submission_schema_1 = require("./claim-submission-schema");
var property_location_submission_schema_1 = require("./property-location-submission-schema");
var remark_submission_schema_1 = require("./remark-submission-schema");
exports.legacyClaimSubmissionSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'approvedLenderID',
        'financialInstitutionID',
        'financialInstitutionTransitNumber',
        'jointPayeeIndicator',
        'lenderLoanNumber',
        'mortgageInsuranceClaimsSystemEditIndicator',
        'totalBedCount',
        'totalUnitCount',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
        'cmhcLoanAccountNumber',
    ],
    properties: {
        legacyClaimSubmissionID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        approvedLenderID: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        financialInstitutionID: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        financialInstitutionTransitNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 5,
            errorMessage: 'should have maximum length of 5 characters',
        },
        jointPayeeIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        jointPayeeName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters or null',
        },
        lenderLoanNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        mortgageInsuranceClaimsSystemEditIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        mortgageInsuranceClaimsSystemLaunchEditDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        totalBedCount: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        totalUnitCount: {
            type: 'integer',
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        cmhcLoanAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        accountInformationSubmission: account_information_submission_schema_1.accountInformationSubmissionSchema,
        borrowerSubmissions: {
            type: 'array',
            items: borrower_submission_schema_1.borrowerSubmissionSchema,
        },
        claimSubmission: claim_submission_schema_1.claimSubmissionSchema,
        propertyLocationSubmission: property_location_submission_schema_1.propertyLocationSubmissionSchema,
        remarkSubmissions: {
            type: ['array', 'null'],
            items: remark_submission_schema_1.remarkSubmissionSchema,
        },
    },
};
